import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './vehicle-rent-page.css'

const VehicleRentPage = (props) => {
  return (
    <div className="vehicle-rent-page-container10">
      <Helmet>
        <title>Vehicle Rent To Own - Help Me Out</title>
        <meta property="og:title" content="Vehicle Rent To Own - Help Me Out" />
        <link rel="canonical" href="https://www.helpmeout.co.za/vehicle-rent-page" />
        <meta property="og:url" content="https://www.helpmeout.co.za/vehicle-rent-page" />
      </Helmet>

      {/* ── Hero ── */}
      <div className="vehicle-rent-page-container11">
        <div className="vehicle-rent-page-container12">
          <div className="vehicle-rent-page-container13">
            <img alt="Help Me Out Logo" src="/hmol%20logo-1500w.png" className="vehicle-rent-page-image1" />
          </div>
          <div className="vehicle-rent-page-container14">
            <span className="vehicle-rent-page-eyebrow">Rent‑to‑Own</span>
            <h1 className="vehicle-rent-page-thq-heading-elm">
              Drive Today.<br />Own Tomorrow.
            </h1>
            <h2 className="vehicle-rent-page-thq-sub-heading-elm">
              Our vehicle rent-to-own program makes it easy for qualified drivers to get a vehicle and work toward ownership with flexible terms.
            </h2>
          </div>
        </div>
      </div>

      <Navbar />

      {/* ── Content ── */}
      <div className="vehicle-rent-page-container21">

        {/* Section 1 — What do you want to drive */}
        <div className="vehicle-rent-page-container22">
          <div className="vehicle-rent-page-container23">
            <h2 className="vehicle-rent-page-text13">
              <span className="vehicle-rent-page-text14">What Do You </span>
              <span className="vehicle-rent-page-text15">Want</span>
              <span className="vehicle-rent-page-text16"> to Drive?</span>
            </h2>
            <span>
              Choose the perfect rent-to-own vehicle for your journey. From affordable compact cars to spacious SUVs and premium options, we offer flexible plans that help you drive today and own tomorrow. Explore our fleet and find the vehicle that fits your lifestyle, comfort, and budget.
            </span>
          </div>
          <img
            alt="2015 Toyota Corolla available for rent-to-own"
            src="/2015-toyota-corolla-1100w.png"
            loading="lazy"
            className="vehicle-rent-page-image2"
          />
        </div>

        {/* Section 2 — Why rental */}
        <div className="vehicle-rent-page-container24">
          <img
            alt="Volkswagen Polo available for rent-to-own"
            src="/polo-1100w.png"
            loading="lazy"
            className="vehicle-rent-page-image3"
          />
          <div className="vehicle-rent-page-container25">
            <h2 className="vehicle-rent-page-text18">
              <span>Why </span>
              <span className="vehicle-rent-page-text20">Rental</span>
              <span> and Not Financing?</span>
            </h2>
            <span>
              Build toward owning your vehicle without the pressure of traditional financing. Rent-to-own gives you flexible payments, lower upfront costs, and a simple path to ownership — no large bank loans or complicated approvals. Choose your car today and drive your way to owning it.
            </span>
          </div>
        </div>

        {/* Section 3 — Contact form */}
        <div className="vehicle-rent-page-thq-container-elm">
          <div className="vehicle-rent-page-container26">
            <h2 className="vehicle-rent-page-text23">
              <span className="vehicle-rent-page-text24">Get In </span>
              <span className="vehicle-rent-page-text25">Touch</span>
            </h2>
            <span>
              Ready to own your car? Contact us today to check availability, get pricing, and start your rent-to-own journey.
            </span>
            <form
              method="POST"
              action="https://test.helpmeout.co.za/api/vehicle-rental-query"
              data-form-id="c996565a-e842-43cc-a7d0-4aa7d0d731d4"
              encType="multipart/form-data"
              className="vehicle-rent-page-form"
            >
              <input
                type="text" id="vehicle_honeypot" name="website" tabIndex="-1"
                spellCheck="false" autoCorrect="off" placeholder="Leave blank"
                autoComplete="new-password" autoCapitalize="off" aria-hidden="true"
                className="vehicle-rent-page-textinput1 input"
              />
              <div className="vehicle-rent-page-container27">
                <label htmlFor="vehicle_name">Name</label>
                <input type="text" id="vehicle_name" name="name" placeholder="Your full name"
                  required className="vehicle-rent-page-textinput2 input" />
              </div>
              <div className="vehicle-rent-page-container28">
                <label htmlFor="vehicle_email">Email</label>
                <input type="email" id="vehicle_email" name="email" placeholder="you@example.com"
                  required className="vehicle-rent-page-textinput3 input" />
              </div>
              <div className="vehicle-rent-page-container29">
                <label htmlFor="vehicle_phone">Phone</label>
                <input type="tel" id="vehicle_phone" name="phone" placeholder="+27 000 000 0000"
                  required className="input" />
              </div>
              <button id="vehicle_submit" name="button" type="submit" className="vehicle-rent-page-button button">
                We'll call you back
              </button>
            </form>
          </div>
          <img
            alt="Kia Picanto available for rent-to-own"
            src="/picanto-1100w.png"
            loading="lazy"
            className="vehicle-rent-page-image4"
          />
        </div>
      </div>

      <Footer
        text={<Fragment><span className="vehicle-rent-page-text30">Authorized Financial Credit Provider</span></Fragment>}
        text1={<Fragment><span className="vehicle-rent-page-text31">Our Partner In Business Funding</span></Fragment>}
        content1={<Fragment><span className="vehicle-rent-page-text32">Apply now for instant financial assistance.</span></Fragment>}
        content2={<Fragment><span className="vehicle-rent-page-text33">Get financial support when you need it most with HelpMeOut.</span></Fragment>}
        copyright={<Fragment><span className="vehicle-rent-page-text34">© {new Date().getFullYear()} HelpMeOut. All rights reserved.</span></Fragment>}
        termsLink={<Fragment><span className="vehicle-rent-page-text35">Terms of Use</span></Fragment>}
        cookiesLink={<Fragment><span className="vehicle-rent-page-text36">Cookies</span></Fragment>}
        privacyLink={<Fragment><span className="vehicle-rent-page-text37">Privacy Policy</span></Fragment>}
      />
    </div>
  )
}

export default VehicleRentPage
